import { api } from './api';
import type {
  MeConfigurationsDetailResponse,
  MeConfigurationsResponse,
  MeRealApartmentsDetailResponse,
  MeRealApartmentsResponse,
} from '@/types';

export const userApi = {
  getMyConfigurations: (): Promise<MeConfigurationsResponse> =>
    api.get<MeConfigurationsResponse>('/api/me/configurations').then((r) => r.data),

  /** Dettaglio configurazioni (nome, date, stato) per la lista "Le tue configurazioni". */
  getMyConfigurationsDetail: (): Promise<MeConfigurationsDetailResponse> =>
    api.get<MeConfigurationsDetailResponse>('/api/me/configurations/detail').then((r) => r.data),

  getMyRealApartments: (): Promise<MeRealApartmentsResponse> =>
    api.get<MeRealApartmentsResponse>('/api/me/real-apartments').then((r) => r.data),

  /** Dettaglio appartamenti (codice, tipologia, edificio/scala/piano/quadrante, configs) per /apartments. */
  getMyRealApartmentsDetail: (): Promise<MeRealApartmentsDetailResponse> =>
    api.get<MeRealApartmentsDetailResponse>('/api/me/real-apartments/detail').then((r) => r.data),
};
